module.exports = {
  ShanghaiPort: 'Шанхайский порт',
  QingdaoPort: 'Циндаоский порт',
  DeletionGuide: 'Руководство по удалению и изменению',
  BusinessData: 'Деловая документация',
  DropOffGoods: 'Выгрузка груза',
  CounterDeletion: 'Удаление заявки через стойку',
  CertificateOfNonBoarding: 'Справка о недогрузке',
  CarrierName: 'Название судового агента',
  Text1: 'Объем услуг (поддерживается платформой',
  Text2: 'Судоходные компании и',
  Text3: 'отправка манифестов судовыми агентами, список следующий:)',
  Text4: 'Руководство по обработке "изменения или удаления предварительного манифеста"',
  Title1: 'Объем услуг — поддержка платформы',
  Title2: 'Отправка VGM судоходными компаниями, список следующий:',
  Remark1: 'Шанхай Чжэньхуа (судовой агент)',
  Remark2: 'DJS (Дунцзинь), ONTO (Аньтун), EAS (Датун), PCS (Фаньчжоу) — запрещены',
  Remark3: 'Шанхай Миньшэн (судовой агент)',
  Remark4: 'Тайваньские и японские линии компании Миньшэн запрещены. Тайваньские линии WHL (Ваньхай) разрешены.',
  Remark5: 'Цзиньчэн (судовой агент)',
  Remark6: 'JJ (Цзиньцзян) — запрещены',
  Remark7: 'Чжэнли (судоходная компания)',
  Remark8: 'Для тайваньских линий "CNC—Чжэнли" выберите код судоходной компании "CST—Баохуа".',
  Remark9: 'Синьдун (судоходная компания)',
  Remark10: 'Для корейской линии Инчхон "NOS—Синьдун" выберите код судоходной компании "NSI—Нинбо Юаньян".',
  Remark11: 'Сингапурское морское судоходство (судоходная компания)',
  Remark12: 'Для дочернего бренда судоходной компании Бяньхан, с номерами коносаментов, начинающихся на SEC, выберите судоходную компанию "SCO—Сингапурское морское судоходство".',
  Remark13: 'Сингапурская морская лидерская судоходная компания (судоходная компания)',
  Remark14: 'FCSL—Вальта ОАЭ является агентом VOLTA в Шанхае, выберите судоходную компанию "SLS—Сингапурская морская лидерская судоходная компания".',
  Remark15: 'Шанхай Чжунлянь (судовой агент)',
  Remark16: 'CUL (Чжунлянь), RPS (Жичжао) — запрещены',
  Remark17: 'До отплытия судна, если не превышен срок подачи манифеста, установленный судовым агентом, и вся партия манифестов не прошла таможенное оформление:',
  Remark18: 'a) Если требуется изменить судоходную компанию, судового агента, номер коносамента, название судна, рейс, номер контейнера, номер пломбы, наименование груза или тип контейнера: выберите исходный манифест в разделе "Отправленные", подайте заявку на удаление манифеста, после удаления отправьте новый манифест. Тип контейнера требует удаления только для четырех судовых агентов: Чжунлянь, OOCL, Sinotrans и Чжэньхуа, для остальных можно подать запрос на изменение напрямую.',
  Remark19: 'b) Если требуется изменить информацию, не входящую в указанные 9 категорий, выберите манифест в разделе "Отправленные", подайте заявку на изменение и дождитесь подтверждения.',
  Remark20: 'c) Для сборных грузов (LCL):',
  Remark21: 'i) Если требуется изменить информацию по одной или нескольким партиям, следуйте пункту b выше.',
  Remark22: 'ii) Если требуется удалить одну или несколько партий, необходимо удалить все манифесты с тем же номером контейнера, а затем отправить новые манифесты.',
  Remark23: 'iii) Если требуется добавить одну партию сборного груза, можно отправить ее напрямую (для судовых агентов Ханхуа и Пэнхуа дополнительный номер подпартии должен быть отправлен вместе с основным номером).',
  Remark24: 'До отплытия судна, но если срок подачи манифеста, установленный судовым агентом, уже истек, или клиент уже прошел таможенное оформление:',
  Remark25: 'a) Если клиент уже прошел таможенное оформление, необходимо сначала отменить таможенную проверку.',
  Remark26: 'b) Уточните у соответствующего судового агента, как выполнить удаление или изменение (можно обратиться в нашу службу поддержки).',
  Remark27: 'c) Если груз уже выпущен, необходимо подать бумажные документы в стойку судового агента для отмены статуса "Выпущено" (можно обратиться в нашу службу поддержки).',
  Remark28: 'После отплытия судна, подача заявки на удаление:',
  Remark29: 'a) Если клиент уже прошел таможенное оформление, необходимо сначала аннулировать таможенную декларацию.',
  Remark30: 'b) Необходимо подать бумажные документы в стойку судового агента для удаления: как правило, требуются следующие 4 документа (для справки): "Заявление на удаление", "Таможенная декларация", "Пояснение к удалению", "Скриншот страницы проверки статуса на таможенном информационном сайте" (мы можем предоставить услуги по оформлению, подробности уточняйте в службе поддержки).',
  Remark31: 'Приложение: адреса стоек судовых агентов',
  CompanyName1: 'Шанхайский внешний агент',
  CompanyName2: 'Шанхайская компания Sinotrans',
  CompanyName3: 'Шанхайская объединенная компания',
  CompanyName4: 'Шанхайская компания Хуаган',
  CompanyName5: 'Шанхайская компания Шуньдэ',
  CompanyName6: 'Шанхай Ханхуа',
  CompanyName7: 'Шанхай Миньшэн',
  CompanyName8: 'Шанхай Пэнхуа',
  CompanyName9: 'Шанхай Пэнхай',
  CompanyName10: 'Шанхай Чжунлянь (Чжунхэ)',
  CompanyName11: 'Шанхай Чжэньхуа',
  CompanyName12: 'Синьхай',
  CompanyName13: 'Цзиньчэн',
  CompanyName14: 'Ориент Оверсиз',
  CompanyName15: 'Шанганг Ляньхэ',
  CompanyName16: 'Шанхай Чжунлянь',
  CompanyName17: 'Пэнхуа',
  CompanyAddress1: 'Хункоу, ул. Усун, д. 531, 5 этаж',
  CompanyAddress2: 'ул. Фуцзянь Чжунлу, д. 188, 3 этаж, холл',
  CompanyAddress3: 'Хункоу, ул. Дундамин, д. 916, 1 этаж',
  CompanyAddress4: 'ул. Дундамин, д. 501, офис 1601',
  CompanyAddress5: 'ул. Хайлунь, д. 440, офис 2701',
  CompanyAddress6: 'Хункоу, ул. Хуанпу, д. 99, 2 этаж',
  CompanyAddress7: 'ул. Далянь, д. 1619, Plaza Junfeng International Fortune, 16 этаж',
  CompanyAddress8: 'Янпу, ул. Сыпин, д. 1063, башня 1, Zhongtian Plaza, 5 этаж, офисы 501, 502, 508',
  CompanyAddress9: 'ул. Яньань Дунлу, д. 700, офисы 1807-1809',
  CompanyAddress10: 'Хункоу, ул. Дундамин, д. 908, 24 этаж',
  CompanyAddress11: 'ул. Яньань Дунлу, д. 700, Plaza Gangtai, 21 этаж',
  CompanyAddress12: 'Хункоу, ул. Тяньтун, д. 133, Shanghai Jahwa Financial Tower, 8 этаж',
  CompanyAddress13: 'ул. Яньань Дунлу, д. 1200, 8 этаж',
  CompanyAddress14: 'ул. Яньань Чжунлу, д. 841, 20 этаж'
}
